import axios from '../lib/axios'
import { buildUrlString } from '@!/Util'

export const getNewBooksApi = async (safeSearch, genreName, page, perPage) => {
  const url = buildUrlString(`/api/v1/new_books`, { safe_search: safeSearch, genre_name: genreName, page: page, per_page: perPage })
  return await axios.get(url)
}

export const getTopNewBooksApi = async (safeSearch, genreName) => {
  const params = {
    safe_search: safeSearch,
  }

  if (genreName) {
    params.genre_name = genreName
  }

  const url = buildUrlString('/api/v1/new_books/top', params)

  return await axios.get(url)
}
